// extracted by mini-css-extract-plugin
export default {"cls1":"ResultsList-ItemContent_cls1__VIjvL","cls2":"ResultsList-ItemContent_cls2__xc-m0 ResultsList-ItemContent_cls1__VIjvL"};